// l10n status: n/a
import React, { Fragment, useEffect, useState } from "react"
import { observer } from "mobx-react"
import { CreateComponent } from "components/utils/CreateComponent"
import { rootStore } from "store/RootStore"
import { PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
import { DiscoverCarousel } from "./DiscoverCarousel"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import { ConfirmationDialog } from "components/ConfirmationDialog"
import { ButtonGeneric } from "scenes/components/ButtonComponents"
import { useMediaQuery } from "hooks/useMediaQyery"
import { DiscoverConst } from "./DiscoverConst"
import { LiveTile } from "./LiveTile"
import { Divider } from "@mui/material"
import { ErrorMessage } from "components/ErrorMessage"
import { l10n } from "store/lang/L10n"
// too slow
//import html2canvas from "html2canvas"
//import { GenreTile } from "./GenreTile"
//import { l10n } from "store/lang/L10n"

import "./Discover.css"
import "./CategorieButtons.css"

let infoMessage = {}

//const DiscoverBody = CreateComponent(null, false, true, ({ page, cocoDiscover }) => {
const DiscoverBody = observer(({ discoverData, page, origin, cocoDiscover, cocoBookmarks }) => {
	//console.debug("discover= entry")

	const [refreshCount, setRefreshCount] = useState(cocoDiscover.refreshCount)
	const [sectionTitleMarginLeft, setSectionTitleMarginLeft] = useState(0)
	// MTVW-947 performance
	// genre lanes are initially hidden to avoid visible layout change effects
	// first part includes hero and first lane for speeding up initial display
	const [renderFirstPartOnly, setRenderFirstPartOnly] = useState(true)
	const [showModalMessage, setShowModalMessage] = useState(false)

	const isModalOpen = rootStore.page.OverlayEventDetails.isShow || page.isShow

	//const isMobile = useMediaQuery(`(max-width: ${DiscoverConst.mobileBreak}px)`)
	const isLiveOnLane = !useMediaQuery(`(max-width: ${DiscoverConst.laneLiveTileBreak}px)`)
	//const isMedium = useMediaQuery(`(min-width: ${DiscoverConst.mobileBreak + 1}px) and (max-width: ${DiscoverConst.mediumBreak}px)`)

	const indentAfterLiveTile = sectionTitleMarginLeft + DiscoverConst.tileWidth + DiscoverConst.tileGap + DiscoverConst.extraGap

	const isPlayerError = rootStore.page?.Player?.error !== null
	const errorOrigin = rootStore.page.OverlayEventDetails.oEvent?.error ? rootStore.page.OverlayEventDetails.oEvent?.error : rootStore.page?.Player?.error

	useEffect(() => {
		setTimeout(() => {
			setRenderFirstPartOnly(false)
		}, 300)
		// MTVW-947: commented
		//cocoDiscover.discover(false).then(() => setRefreshCount(cocoDiscover.refreshCount))
	}, [])

	// MTVW-966: refresh on profile change, not necessary! done in loginAsync after profile change
	/*
	useEffect(() => {
		cocoBookmarks.getBookmarksAsync(true)
		cocoDiscover.discover(true)
	}, [rootStore.sso?.profile?.loginResult])
	*/

	useEffect(() => {
		if (page.sectionTitleMarginLeft[origin] !== sectionTitleMarginLeft) setSectionTitleMarginLeft(page.sectionTitleMarginLeft[origin])
	}, [page.sectionTitleMarginLeft[origin]])

	// this will do a re-render after a interactionEvent that calls getBookmarksAsync via notifyStopped
	useEffect(() => {
		//console.debug("useEffect DiscoverBody", !isModalOpen, cocoDiscover.refreshCount)
		if (!isModalOpen && cocoDiscover.refreshCount > 0) {
			//console.debug("discover= no skip", refreshCount, cocoDiscover.refreshCount)
			setRefreshCount(cocoDiscover.refreshCount)
		}
		//else console.debug("discover= skip", refreshCount, cocoDiscover.refreshCount)
	}, [cocoDiscover.refreshCount /*,cocoBookmarks.refreshCount*/])

	// MTVW-947: additional useEffect to avoid occasional residual show frame on iPad when closing overlay with playing movie
	useEffect(() => {
		//console.debug("scrollTop", page.discoverScrollPos, isModalOpen, window.scrollY)
		if (!isModalOpen) {
			cocoDiscover.discover(false).then(() => {
				setRefreshCount(cocoDiscover.refreshCount)
			})
			/*
			if (page.discoverScrollPos) window.scrollTo({
				top: page.discoverScrollPos,
				left: 0,
				behavior: 'smooth'
			})
			*/
		}
	}, [rootStore.page.OverlayEventDetails.isShow, page.isShow])

	/* too slow, it takes about 7 seconds
	function takeDiscoverSnapshot() {
		// DRM could create SecurityError
		try {
			const canvas = document.createElement('canvas')
			const bodyElem = document.getElementsByClassName("DiscoverBody")?.[0]
			const bodyRect = bodyElem?.getBoundingClientRect()
			console.debug("discoverSnapshot2", bodyElem, bodyRect)

			if (bodyElem && bodyRect) {
				html2canvas(document.body).then((canvas) => {
					const image = canvas.toDataURL('image/jpg')
					console.debug("discoverSnapshot3", image)
				})
			}
		}
		catch (err) {
			console.error("discoverSnapshot", err)
		}
	}
	*/

	/*
	const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())
	const [windowWidthDimensions, setWindowWidthDimensions] = useState(getWindowWidthDimentsions())

	const handleResize = () => {
		setWindowDimensions(getWindowDimensions())
		setWindowWidthDimensions(getWindowWidthDimentsions())
	}
	*/

	const clickHandler = (item) => {
		cocoDiscover.getCategory(item.id).then((res) => {
			//console.debug("clickHandler item %o, categories[0] %o, res %o", item, res?.categories[0], res)
			// MTVW-971: Plausibility checks
			if (!item || !res || !res.categories[0]) throw new Error("Missing data")
			page.setDiscoverCategory({ topCategory: item, selected: res.categories[0], children: res }).setShow(true/*, CALLING_CONTEXT_TYPE.Search*/)
		}).catch((e) => {
			console.error("Discover getCategory", e)
			infoMessage = {
				title: l10n.problemTitleGenericNotFound,
				content: l10n.problemDetailGenericNotFound,
				button1: l10n.commonActionClose,
				toLiveTv: false
			}
			setShowModalMessage(true)
		})
	}

	const closeModalMessage = () => {
		const toLiveTv = infoMessage.toLiveTv
		infoMessage = {}
		setShowModalMessage(false)
		if (toLiveTv) rootStore.sso.selectLiveTv()
	}

	// MTVW-967
	if (!showModalMessage && refreshCount > 0 && (cocoDiscover.heroes?.length === 0 || cocoDiscover.lanes.length === 0)) {
		infoMessage = {
			title: l10n.problemTitleGenericNotFound,
			content: l10n.problemDetailGenericNotFound,
			button1: l10n.commonActionClose,
			toLiveTv: true
		}
		setShowModalMessage(true)
	}

	return (
		/*!rootStore.page.OverlayEventDetails.isVisible &&*/
		<div className="DiscoverBody">
			{/*console.debug("discover= render", refreshCount, isModalOpen)*/}
			{showModalMessage &&
				<ConfirmationDialog
					title={infoMessage.title}
					onCloseHandler={() => {
						closeModalMessage()
					}}
					data-test="modal_message"
					bottomButtons={
						[{
							bType: ButtonGeneric,
							props: {
								bId: `buttonClose`, variant: "primary",
								label: infoMessage.button1,
								onClick: function () {
									closeModalMessage()
								},
								dataTest: "modal_message_confirm_button"
							}
						},
						]
					}
				>
					{infoMessage.content}
				</ConfirmationDialog>
			}
			<div className="ErrorPosition" >
				{!rootStore.page.OverlayEventDetails.isVisible && (
					<ErrorMessage error={errorOrigin} isPlayerError={isPlayerError} classes={{ ErrorInfoWrapper: "ErrorInfoWrapper" }} page={page} id="player" />
				)}
			</div>
			<div className="DiscoverBackground">
				<div className="HeroFrame">
					{refreshCount > 0 && discoverData.heroes?.length > 0 &&
						<DiscoverCarousel variant={"hero"} page={page} lane={null} contentArray={discoverData.heroes} origin={PROGRAM_ORIGIN.discover} />}
				</div>
				{/* DO NOT SHOW category buttons on first render */}
				<div style={{ visibility: renderFirstPartOnly ? "hidden" : "visible" }}>
					<div className="categoriesPadding" />
					<DiscoverCarousel variant={"catButton"} page={page} lane={null} contentArray={cocoDiscover.categories} origin={PROGRAM_ORIGIN.discover} clickHandler={clickHandler} />
				</div>
				{refreshCount > 0 && discoverData.lanes?.length > 0 &&
					discoverData.lanes.map((item, ix) => (
						<div key={item.id} style={{ visibility: ix === 0 ? "visible" : renderFirstPartOnly ? "hidden" : "visible" }}>
							<Fragment>
								{/* MTVW-947: performance, limit to hero and first lane if overlay is open */}
								{/* !isModalOpen causes repositioning when overlay is open!
								    not necessary anymore with discover updates disabled in CoCoBookmarks.getBookmarksAsync while in overlay*/}
								{((/*!isModalOpen &&*/ (!renderFirstPartOnly)) || ix === 0) &&
									<>
										{isLiveOnLane ?
											<div id={item.id} className="DiscoverLane" style={{ left: ix === 0 ? indentAfterLiveTile ? indentAfterLiveTile : 0 : "" }}>
												<div className="SectionTitle" style={{ marginLeft: ix === 0 ? 0 : sectionTitleMarginLeft ?? "" }}>
													{item.title /*item.id === "most-popular" ? l10n.featureDiscoverMostPopular :*/}
												</div>
												{ix === 0 &&
													<>
														<div className="SectionTitle" style={{ position: "absolute", top: -50, left: indentAfterLiveTile ? -indentAfterLiveTile : 0, marginLeft: sectionTitleMarginLeft ?? "" }}>
															{l10n.featureDiscoverNowLive}
														</div>
														<div style={{ position: "absolute", left: -(DiscoverConst.tileWidth + DiscoverConst.tileGap + DiscoverConst.extraGap) }}>
															<LiveTile page={page} origin={origin} />
														</div>
														<div style={{ position: "absolute", height: 104, width: 4, bottom: 85, left: -(DiscoverConst.extraGap) }}>
															<Divider id="liveDivider" orientation="vertical" flexItem
																sx={{ height: 104, borderRightWidth: 4, borderRadius: 2, borderColor: "#CCCCCC" }} />
														</div>
													</>
												}
												{/* MTVW-931: add origin*/}
												{/*ix === 0 && console.debug("laneItem", item.items.length, item.items)*/}
												<DiscoverCarousel variant={"lane"} page={page} lane={item} contentArray={item.items} origin={PROGRAM_ORIGIN.discover} hasLiveTile={ix === 0} />
												{/*console.debug("lane items", item.items)*/}
											</div>
											:
											<>
												{ix === 0 &&
													<LiveTile page={page} />
												}
												<div className="DiscoverLane">
													<div className="SectionTitle" style={{ marginLeft: sectionTitleMarginLeft ?? "" }}>
														{item.title}
													</div>
													<DiscoverCarousel variant={"lane"} page={page} lane={item} contentArray={item.items} origin={PROGRAM_ORIGIN.discover} />
												</div>
											</>
										}
									</>
								}
							</Fragment>
						</div>
					))
				}
			</div>
		</div>
	)
})

export const Discover = observer(() => {
	const page = rootStore.page.Discover
	const cocoDiscover = rootStore.page.CoCoDiscover
	const cocoBookmarks = rootStore.page.CoCoBookmarks

	const [discoverData, setDiscoverData] = useState({ lanes: [], heroes: [] })

	function liveFilter(liveEvent) {
		return { lanes: cocoDiscover.lanes, heroes: cocoDiscover.heroes }
		/* MTVW-980: There was a request do filter the live event out of the continue watching lane, but then the request was reverted
		// make a copy of the lanes array
		const lanes = cocoDiscover.lanes.slice()
		if (lanes?.[0]?.id === "continue_watching") {
			const filtered = lanes?.[0]?.items.filter(item => {
				if (item?.program?.id) console.debug("program", lanes[0], item, item?.program?.id, liveEvent, liveEvent?.id)
				if (item?.seriesEpisode?.id) console.debug("seriesEpisode", lanes[0], item, item?.seriesEpisode?.id, liveEvent, liveEvent?.id)
				if (rootStore.channelsService.activeChannelId === item.program?.channelId && item?.program?.id === liveEvent?.id) {
					//console.debug("hit program")
					return false
				}
				else if (rootStore.channelsService.activeChannelId === item.seriesEpisode?.channelId && item?.seriesEpisode?.id === liveEvent?.id) {
					//console.debug("hit seriesEpisode")
					return false
				}
				else {
					return true
				}
			})
			//console.debug("liveFilter continue_watching", filtered, filtered.length, lanes[0].id, lanes[0].items.length, lanes[0].items)
			if (filtered.length > 0) lanes[0].items = filtered
			else lanes.shift()
		}
		//console.debug("liveFilter leaving")
		// make a copy of the heroes array
		const heroes = cocoDiscover.heroes.slice()
		return { lanes: lanes, heroes: heroes }
		*/
	}


	useEffect(() => {
		const pageWrapper = document.getElementById("pageWrapper")
		if (pageWrapper) pageWrapper.style.width = "100vw"
		/*
		setTimeout(() => {
			setRenderFirstPartOnly(false)
		}, 300)
		*/

		setDiscoverData(liveFilter(page.liveEvent))
		page.setPlayStarted(false)
		// MTVW-955
		rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.discover })
		return () => {
			if (page.liveEvent) page.setLiveEvent(null)
		}
	}, [])

	useEffect(() => {
		setDiscoverData(liveFilter(page.liveEvent))
	}, [cocoDiscover.refreshCount])

	/* not needed anymore, causes visual refresh
	useEffect(() => {
		setDiscoverData(liveFilter(page.liveEvent))
	}, [page.liveEvent])
	*/


	/*
	useEffect(
		...page.getMountBody(
			() => {
			},
			() => {
			}
		)
	)
	*/

	// MTVW-980: not needed anynore, key to force refresh, causes visual refresh
	//<DiscoverBody key={`discover${page.liveEvent}`} discoverData={discoverData} page={page} origin={PROGRAM_ORIGIN.discover} cocoDiscover={cocoDiscover} cocoBookmarks={cocoBookmarks} />

	return (
		<DiscoverBody discoverData={discoverData} page={page} origin={PROGRAM_ORIGIN.discover} cocoDiscover={cocoDiscover} cocoBookmarks={cocoBookmarks} />
	)
})
